import dayjs from "dayjs";
import { t } from "i18next";
import * as yup from "yup";

const currentYear = dayjs().year();

export const FILTER_VALIDATION_SCHEMA = yup.object().shape({
  year: yup
    .string()
    .matches(/^\d{4}$/, t("errors.yearMustBe4DigitNumber"))
    .test("valid-year", t("errors.enterValidYear"), value =>
      value ? Number(value) <= currentYear : true
    ),
});

export const FILTER_INITIAL_VALUES = {
  year: "",
  movie: true,
  series: true,
};

export const TYPE = {
  movie: "movie",
  series: "series",
};
